import styles from "./TextInput2.module.css";

const TextInput2 = () => {
  return (
    <div className={styles.textInput}>
      <div className={styles.placeholder}>Placeholder</div>
    </div>
  );
};

export default TextInput2;
